import type { Option } from '@comparit/core';
import { Beschaeftigungsart } from '../../../interfaces';

/**
 * The Sparte only distinguishes the öffentlicher Dienst, which some Versicherer tarifieren
 * günstiger, so the funnel asks exactly that rather than a Berufsgruppe it would discard.
 */
export const beschaeftigungsartOptions: Option<Beschaeftigungsart>[] = [
  { label: 'Angestellt oder sonstige', value: Beschaeftigungsart.Normal },
  { label: 'Öffentlicher Dienst oder verbeamtet', value: Beschaeftigungsart.OeffentlicherDienst },
];
